// 9fbef606107a605d69c0edbcd8029e5d
import { parseBoolean } from '@tcp/core/src/utils';
import isEmpty from 'lodash/isEmpty';
import { getIsBgdImageOverrideEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { SESSIONCONFIG_REDUCER_KEY } from '../../constants/reducer.constants';
import { safelyParseJSON } from '../../utils/utils';

//  TODO - Remove once Label cleanup is completed

export const getAddBgdToTransparentImgEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ADD_BGD_TO_TRANSPARENT_IMG_ENABLED)
  );
};

/* Format : {
  tcp: '#ebebeb',
  snj: '#ebebeb',
  gym: '#ffffff',
  pjp: 'rgb(235, 235, 235)',
} */
export const getBrandBgdImg = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.BRAND_BGD_IMG_CONFIG
  );
};

export const getImgBackgroundColorForPng = (state) => {
  const backgroundColorsForPng =
    state?.[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.IMG_BGD_COLOR_FOR_PNG;

  const parsedBackgroundColors = safelyParseJSON(backgroundColorsForPng) || {};
  const brandBackgroundImages = getIsBgdImageOverrideEnabled(state)
    ? safelyParseJSON(getBrandBgdImg(state)) || {}
    : {};

  const hasOriginal = !isEmpty(parsedBackgroundColors);
  const hasOverride = !isEmpty(brandBackgroundImages);

  if (hasOriginal && hasOverride) {
    const mergedConfig = { ...parsedBackgroundColors };
    return {
      ...mergedConfig,
      ...brandBackgroundImages,
    };
  }

  if (hasOriginal && !hasOverride) {
    return parsedBackgroundColors;
  }

  if (!hasOriginal && hasOverride) {
    return brandBackgroundImages;
  }

  return {};
};

export const getIsDamImageV2Enabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_DAMIMAGE_V2_ENABLED)
  );
};

export const getIsDamImageV2EnabledPLP = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_DAMIMAGE_V2_ENABLED_PLP)
  );
};

export const getIsDamImageV2EnabledPDP = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_DAMIMAGE_V2_ENABLED_PDP)
  );
};

export const getIsGroupModulesEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_GROUP_MODULES_ENABLED)
  );
};

export const getIsGroupModulesEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_GROUP_MODULES_ENABLED_APP)
  );
};

export const getOutfitPillWidthVal = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.OUTFIT_PILL_WIDTH) ||
    ''
  );
};

export const getOutfitPillHeightVal = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.OUTFIT_PILL_HEIGHT) ||
    ''
  );
};
export const getOutfitPillColorVal = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.OUTFIT_PILL_COLOR) ||
    ''
  );
};
export const getOutfitPillFontSizeVal = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.OUTFIT_PILL_FONT_SIZE) ||
    ''
  );
};

export const getIsHeaderSectionDisabledWeb = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_OUTFIT_HEADER_SECTION_DISABLED_WEB)
  );
};

export const getIsHeaderSectionDisabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_OUTFIT_HEADER_SECTION_DISABLED_APP)
  );
};

export const getOutfitPillBgColorVal = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.OUTFIT_PILL_BG_COLOR) ||
    ''
  );
};
